<shared-alert></shared-alert>
<app-loader></app-loader>
<router-outlet></router-outlet>
<shared-floatui-display></shared-floatui-display>
